import styled from 'styled-components';

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;
  justify-content: center;
  width: 100%;
  gap: 8px;
`;

export const Row = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  width: 100%;
  gap: 32px;

  >span {
    margin: 0;
    width: 100%;
    margin-right: auto;
  }
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  gap: 16px;

  ${props => props.theme.mediaQuerie.maxWidth.sm} {
    width: 100%;
  }
`;

export const RowGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 32px;

  ${props => props.theme.mediaQuerie.maxWidth.md}{
    grid-template-columns: 1fr;
    grid-template-rows: auto;
  }
`;

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 16px;

  ${props => props.theme.mediaQuerie.maxWidth.sm} {
    justify-content: space-between;
  }
`;